import styled from 'styled-components'

import Form from '../../../../../../shared/components/Form'
import { colors } from '../../../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
  padding-top: 30px;
`

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
`

export const StyledForm = styled(Form)`
  padding-top: 20px;
`

export const Label = styled.span`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;

  padding-bottom: 5px;
`

export const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;

  & > label {
    margin-right: 16px;
  }
`
